import React from "react";
import ReactDOM from "react-dom";
import { RelativePlacement } from "./position-utils";
import style from "./floaters.module.css";
import { Floater, FloaterProps } from "./floater";
import { PortalID } from "frontend/modal/portal-types";
import cn from "classnames";
import { useIsCIMReorderEnabled } from "utils/url-utils";

export function Tooltip({
  design = "default",
  relativeTo,
  label,
  side = "top",
  boundary,
  margin,
  customStyle,
  withArrow = true,
  arrowSize,
}: {
  design?: "default" | "monday";
  label: string | JSX.Element | React.ReactNode;
  relativeTo: FloaterProps["relativeTo"];
  side?: RelativePlacement;
  boundary?: DOMRectReadOnly | string;
  margin?: number;
  customStyle?: React.CSSProperties;
  withArrow?: boolean;
  arrowSize?: number;
}) {
  const portal = document.getElementById(PortalID.Tooltips);
  const isCimReorderEnabled = useIsCIMReorderEnabled();

  const element = (
    <Floater
      className={cn(style.tooltip, (design === "monday" || isCimReorderEnabled) && style.mondayTooltip)}
      relativeTo={relativeTo}
      side={side}
      boundary={boundary}
      extraStyle={customStyle}
      margin={margin}
      arrowSize={withArrow ? arrowSize : 0}
    >
      {label}
    </Floater>
  );
  return portal ? ReactDOM.createPortal(element, portal) : element;
}
